var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrikethrough(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "#6C737F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1 13C12.9 12.9 12.7 12.8 12.6 12.7C12.2 12.5 12 12.2 12 11.8C12 11.4 12.2 11.1 12.5 10.8C12.8 10.5 13.3 10.4 13.8 10.4C14.4 10.4 14.9 10.5 15.2 10.8C15.5 11.1 15.7 11.5 15.7 12H18.1C18.1 11.3 17.9 10.7 17.6 10.1C17.3 9.5 16.7 9.1 16.1 8.8C15.5 8.5 14.7 8.5 13.9 8.5C13.1 8.5 12.3 8.6 11.6 8.9C10.9 9.2 10.5 9.6 10.1 10.1C9.8 10.6 9.6 11.1 9.6 11.8C9.6 12.2 9.7 12.7 9.9 13H13.1ZM14.9 16C15 16.1 15.2 16.2 15.3 16.2C15.6 16.4 15.8 16.8 15.8 17.2C15.8 17.6 15.6 17.9 15.3 18.2C15 18.5 14.5 18.6 13.9 18.6C12.4 18.6 11.6 18 11.6 16.7H9.2C9.2 17.5 9.4 18.1 9.8 18.7C10.2 19.3 10.8 19.7 11.5 20.1C12.2 20.3 13 20.5 13.9 20.5C15.2 20.5 16.2 20.2 17 19.6C17.8 19 18.1 18.2 18.1 17.2C18.1 16.7 18 16.3 17.9 15.9H14.9V16ZM8 13.9H20V15.1H8V13.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikethrough);
export default __webpack_public_path__ + "static/media/strikethrough.0408b832c9001c8aba672edbdf66b398.svg";
export { ForwardRef as ReactComponent };